(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-coin-builder"] && !Shopify.designMode) return;
  try {
    (function(){
  function money(value){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(value);
  }

  function init(root){
    var intro=root.querySelector('[data-intro]');
    var wizard=root.querySelector('[data-wizard]');
    var start=root.querySelector('[data-start]');
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var stepTitle=root.querySelector('[data-step-title]');
    var next=root.querySelector('[data-next]');
    var back=root.querySelector('[data-back]');
    var form=root.querySelector('form');
    var qty=root.querySelector('[data-qty]');
    var cartQty=root.querySelector('[data-cart-qty]');
    var unitProp=root.querySelector('[data-unit-prop]');
    var totalProp=root.querySelector('[data-total-prop]');
    var tierProp=root.querySelector('[data-tier-prop]');
    var review=root.querySelector('[data-review]');
    var pricing=JSON.parse(root.querySelector('[data-pricing]').textContent);
    var current=0;

    function clearError(step){
      var error=step.querySelector('[data-error]');
      if(error){error.hidden=true;error.textContent='';}
    }

    function showError(step,message){
      var error=step.querySelector('[data-error]');
      if(error){error.textContent=message;error.hidden=false;}
    }

    function tierFor(quantity){
      var tier=pricing.tiers[0];
      pricing.tiers.forEach(function(candidate){
        if(quantity>=candidate.min&&(candidate.max===null||quantity<=candidate.max)){tier=candidate;}
      });
      return tier;
    }

    function quantityValue(){
      var raw=qty.value.trim();
      if(raw===''){return null;}
      var value=Number(raw);
      if(!Number.isInteger(value)){return null;}
      return value;
    }

    function syncPrice(){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);
      if(quantity===null||quantity<min){
        return;
      }
      var tier=tierFor(quantity);
      cartQty.value=quantity;
      unitProp.value=money(tier.price);
      totalProp.value=money(tier.price*quantity);
      tierProp.value=String(tier.min)+(tier.max===null?'+':'–'+tier.max)+' @ '+money(tier.price);
    }

    function filterImprints(){
      var base=root.querySelector('[data-base]:checked');
      [].slice.call(root.querySelectorAll('[data-for-base]')).forEach(function(card){
        var show=base&&card.dataset.forBase===base.value;
        card.hidden=!show;
        var input=card.querySelector('[data-imprint]');
        if(input&&!show){input.checked=false;}
      });
    }

    function updateArt(group){
      var selected=group.querySelector('[data-mode]:checked');
      var step=group.closest('[data-step]');
      [].slice.call(step.querySelectorAll('[data-panel]')).forEach(function(panel){
        panel.hidden=!selected||panel.dataset.panel!==selected.dataset.mode;
      });
    }

    function validateStep(){
      var step=steps[current];
      clearError(step);

      if(current===0){
        var quantity=quantityValue();
        var min=Number(root.dataset.min);
        if(quantity===null){
          showError(step,'Enter the number of coins you want.');
          qty.focus();
          return false;
        }
        if(quantity<min){
          showError(step,'Minimum order is '+min+'. Please enter '+min+' or more.');
          qty.focus();
          return false;
        }
        syncPrice();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===1){
        if(!root.querySelector('[data-base]:checked')){
          showError(step,'Choose a chip color.');
          return false;
        }
        filterImprints();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===2){
        if(!root.querySelector('[data-imprint]:checked')){
          showError(step,'Choose an imprint color.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='aluminum'&&current===1){
        if(!root.querySelector('input[name="properties[Kalodized Coating]"]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='bronze'&&current===1){
        if(!root.querySelector('input[name="properties[Stock Die]"]:checked')){
          showError(step,'Choose an option.');
          return false;
        }
        return true;
      }

      if(step.querySelector('[data-art-group]')){
        if(!step.querySelector('[data-mode]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
      }

      return true;
    }

    function value(name){
      var el=root.querySelector('[name="'+name+'"]:checked')||root.querySelector('[name="'+name+'"]');
      return el?(el.value||''):'';
    }

    function renderReview(){
      syncPrice();
      var rows=[
        ['Quantity',qty.value],
        ['Price each',unitProp.value],
        ['Estimated total',totalProp.value]
      ];

      if(root.dataset.kind==='plastic'){
        rows.push(['Chip color',value('properties[Base Chip Color]')]);
        rows.push(['Imprint color',value('properties[Imprint Color]')]);
      } else if(root.dataset.kind==='aluminum'){
        rows.push(['Colored coating',value('properties[Kalodized Coating]')]);
      } else if(root.dataset.kind==='bronze'){
        rows.push(['Stock die',value('properties[Stock Die]')]);
      }

      rows.push(['Front',value('properties[Front Design Source]')]);

      if(Number(root.dataset.sides)===2){
        rows.push(['Back',value('properties[Back Design Source]')]);
      }

      review.innerHTML='';

      rows.forEach(function(row){
        var item=document.createElement('div');
        item.className='ccw__review-row';
        var label=document.createElement('b');
        label.textContent=row[0];
        var val=document.createElement('span');
        val.textContent=row[1];
        item.appendChild(label);
        item.appendChild(val);
        review.appendChild(item);
      });
    }

    function show(index){
      current=Math.max(0,Math.min(index,steps.length-1));

      steps.forEach(function(step,i){
        step.classList.toggle('is-active',i===current);
      });

      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===current);
      });

      stepTitle.textContent='Step '+(current+1)+' of '+steps.length+' · '+steps[current].dataset.label;
      back.hidden=current===0;
      next.hidden=current===steps.length-1;

      if(current===steps.length-1){
        renderReview();
      }
    }

    start.addEventListener('click',function(){
      intro.hidden=true;
      wizard.hidden=false;
      show(0);
      setTimeout(function(){qty.focus();},0);
    });

    qty.addEventListener('input',function(){
      clearError(steps[0]);
      syncPrice();
    });

    root.addEventListener('change',function(event){
      var step=event.target.closest('[data-step]');
      if(step){clearError(step);}

      if(event.target.matches('[data-base]')){
        filterImprints();
      }

      if(event.target.matches('[data-mode]')){
        updateArt(event.target.closest('[data-art-group]'));
      }
    });

    next.addEventListener('click',function(){
      if(validateStep()){show(current+1);}
    });

    back.addEventListener('click',function(){
      show(current-1);
    });

    form.addEventListener('submit',function(event){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);

      if(quantity===null||quantity<min){
        event.preventDefault();
        show(0);
        showError(steps[0],'Minimum order is '+min+'. Please enter '+min+' or more.');
        qty.focus();
        return;
      }

      syncPrice();
    });

    filterImprints();
    [].slice.call(root.querySelectorAll('[data-art-group]')).forEach(updateArt);
  }

  document.querySelectorAll('[data-ccw]').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-coin-wizard-v1634"] && !Shopify.designMode) return;
  try {
    (function(){
  function money(value){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(value);
  }

  function init(root){
    var intro=root.querySelector('[data-intro]');
    var wizard=root.querySelector('[data-wizard]');
    var start=root.querySelector('[data-start]');
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var stepTitle=root.querySelector('[data-step-title]');
    var next=root.querySelector('[data-next]');
    var back=root.querySelector('[data-back]');
    var form=root.querySelector('form');
    var qty=root.querySelector('[data-qty]');
    var cartQty=root.querySelector('[data-cart-qty]');
    var unitProp=root.querySelector('[data-unit-prop]');
    var totalProp=root.querySelector('[data-total-prop]');
    var tierProp=root.querySelector('[data-tier-prop]');
    var review=root.querySelector('[data-review]');
    var pricing=JSON.parse(root.querySelector('[data-pricing]').textContent);
    var current=0;

    function clearError(step){
      var error=step.querySelector('[data-error]');
      if(error){error.hidden=true;error.textContent='';}
    }

    function showError(step,message){
      var error=step.querySelector('[data-error]');
      if(error){error.textContent=message;error.hidden=false;}
    }

    function tierFor(quantity){
      var tier=pricing.tiers[0];
      pricing.tiers.forEach(function(candidate){
        if(quantity>=candidate.min&&(candidate.max===null||quantity<=candidate.max)){tier=candidate;}
      });
      return tier;
    }

    function quantityValue(){
      var raw=qty.value.trim();
      if(raw===''){return null;}
      var value=Number(raw);
      if(!Number.isInteger(value)){return null;}
      return value;
    }

    function syncPrice(){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);
      if(quantity===null||quantity<min){
        return;
      }
      var tier=tierFor(quantity);
      cartQty.value=quantity;
      unitProp.value=money(tier.price);
      totalProp.value=money(tier.price*quantity);
      tierProp.value=String(tier.min)+(tier.max===null?'+':'–'+tier.max)+' @ '+money(tier.price);
    }

    function filterImprints(){
      var base=root.querySelector('[data-base]:checked');
      [].slice.call(root.querySelectorAll('[data-for-base]')).forEach(function(card){
        var show=base&&card.dataset.forBase===base.value;
        card.hidden=!show;
        var input=card.querySelector('[data-imprint]');
        if(input&&!show){input.checked=false;}
      });
    }

    function updateArt(group){
      var selected=group.querySelector('[data-mode]:checked');
      var step=group.closest('[data-step]');
      [].slice.call(step.querySelectorAll('[data-panel]')).forEach(function(panel){
        panel.hidden=!selected||panel.dataset.panel!==selected.dataset.mode;
      });
    }

    function validateStep(){
      var step=steps[current];
      clearError(step);

      if(current===0){
        var quantity=quantityValue();
        var min=Number(root.dataset.min);
        if(quantity===null){
          showError(step,'Enter the number of coins you want.');
          qty.focus();
          return false;
        }
        if(quantity<min){
          showError(step,'Minimum order is '+min+'. Please enter '+min+' or more.');
          qty.focus();
          return false;
        }
        syncPrice();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===1){
        if(!root.querySelector('[data-base]:checked')){
          showError(step,'Choose a chip color.');
          return false;
        }
        filterImprints();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===2){
        if(!root.querySelector('[data-imprint]:checked')){
          showError(step,'Choose an imprint color.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='aluminum'&&current===1){
        if(!root.querySelector('input[name="properties[Kalodized Coating]"]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='bronze'&&current===1){
        if(!root.querySelector('input[name="properties[Stock Die]"]:checked')){
          showError(step,'Choose an option.');
          return false;
        }
        return true;
      }

      if(step.querySelector('[data-art-group]')){
        if(!step.querySelector('[data-mode]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
      }

      return true;
    }

    function value(name){
      var el=root.querySelector('[name="'+name+'"]:checked')||root.querySelector('[name="'+name+'"]');
      return el?(el.value||''):'';
    }

    function renderReview(){
      syncPrice();
      var rows=[
        ['Quantity',qty.value],
        ['Price each',unitProp.value],
        ['Estimated total',totalProp.value]
      ];

      if(root.dataset.kind==='plastic'){
        rows.push(['Chip color',value('properties[Base Chip Color]')]);
        rows.push(['Imprint color',value('properties[Imprint Color]')]);
      } else if(root.dataset.kind==='aluminum'){
        rows.push(['Colored coating',value('properties[Kalodized Coating]')]);
      } else if(root.dataset.kind==='bronze'){
        rows.push(['Stock die',value('properties[Stock Die]')]);
      }

      rows.push(['Front',value('properties[Front Design Source]')]);

      if(Number(root.dataset.sides)===2){
        rows.push(['Back',value('properties[Back Design Source]')]);
      }

      review.innerHTML='';

      rows.forEach(function(row){
        var item=document.createElement('div');
        item.className='ccw__review-row';
        var label=document.createElement('b');
        label.textContent=row[0];
        var val=document.createElement('span');
        val.textContent=row[1];
        item.appendChild(label);
        item.appendChild(val);
        review.appendChild(item);
      });
    }

    function show(index){
      current=Math.max(0,Math.min(index,steps.length-1));

      steps.forEach(function(step,i){
        step.classList.toggle('is-active',i===current);
      });

      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===current);
      });

      stepTitle.textContent='Step '+(current+1)+' of '+steps.length+' · '+steps[current].dataset.label;
      back.hidden=current===0;
      next.hidden=current===steps.length-1;

      if(current===steps.length-1){
        renderReview();
      }
    }

    start.addEventListener('click',function(){
      intro.hidden=true;
      wizard.hidden=false;
      show(0);
      setTimeout(function(){qty.focus();},0);
    });

    qty.addEventListener('input',function(){
      clearError(steps[0]);
      syncPrice();
    });

    root.addEventListener('change',function(event){
      var step=event.target.closest('[data-step]');
      if(step){clearError(step);}

      if(event.target.matches('[data-base]')){
        filterImprints();
      }

      if(event.target.matches('[data-mode]')){
        updateArt(event.target.closest('[data-art-group]'));
      }
    });

    next.addEventListener('click',function(){
      if(validateStep()){show(current+1);}
    });

    back.addEventListener('click',function(){
      show(current-1);
    });

    form.addEventListener('submit',function(event){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);

      if(quantity===null||quantity<min){
        event.preventDefault();
        show(0);
        showError(steps[0],'Minimum order is '+min+'. Please enter '+min+' or more.');
        qty.focus();
        return;
      }

      syncPrice();
    });

    filterImprints();
    [].slice.call(root.querySelectorAll('[data-art-group]')).forEach(updateArt);
  }

  document.querySelectorAll('[data-ccw]').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-coin-wizard-v1635"] && !Shopify.designMode) return;
  try {
    (function(){
  function money(value){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(value);
  }

  function init(root){
    var intro=root.querySelector('[data-intro]');
    var wizard=root.querySelector('[data-wizard]');
    var start=root.querySelector('[data-start]');
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var stepTitle=root.querySelector('[data-step-title]');
    var next=root.querySelector('[data-next]');
    var back=root.querySelector('[data-back]');
    var form=root.querySelector('form');
    var qty=root.querySelector('[data-qty]');
    var cartQty=root.querySelector('[data-cart-qty]');
    var unitProp=root.querySelector('[data-unit-prop]');
    var totalProp=root.querySelector('[data-total-prop]');
    var tierProp=root.querySelector('[data-tier-prop]');
    var review=root.querySelector('[data-review]');
    var pricing=JSON.parse(root.querySelector('[data-pricing]').textContent);
    var current=0;

    function clearError(step){
      var error=step.querySelector('[data-error]');
      if(error){error.hidden=true;error.textContent='';}
    }

    function showError(step,message){
      var error=step.querySelector('[data-error]');
      if(error){error.textContent=message;error.hidden=false;}
    }

    function tierFor(quantity){
      var tier=pricing.tiers[0];
      pricing.tiers.forEach(function(candidate){
        if(quantity>=candidate.min&&(candidate.max===null||quantity<=candidate.max)){tier=candidate;}
      });
      return tier;
    }

    function quantityValue(){
      var raw=qty.value.trim();
      if(raw===''){return null;}
      var value=Number(raw);
      if(!Number.isInteger(value)){return null;}
      return value;
    }

    function syncPrice(){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);
      if(quantity===null||quantity<min){
        return;
      }
      var tier=tierFor(quantity);
      cartQty.value=quantity;
      unitProp.value=money(tier.price);
      totalProp.value=money(tier.price*quantity);
      tierProp.value=String(tier.min)+(tier.max===null?'+':'–'+tier.max)+' @ '+money(tier.price);
    }

    function filterImprints(){
      var base=root.querySelector('[data-base]:checked');
      [].slice.call(root.querySelectorAll('[data-for-base]')).forEach(function(card){
        var show=base&&card.dataset.forBase===base.value;
        card.hidden=!show;
        var input=card.querySelector('[data-imprint]');
        if(input&&!show){input.checked=false;}
      });
    }

    function updateArt(group){
      var selected=group.querySelector('[data-mode]:checked');
      var step=group.closest('[data-step]');
      [].slice.call(step.querySelectorAll('[data-panel]')).forEach(function(panel){
        panel.hidden=!selected||panel.dataset.panel!==selected.dataset.mode;
      });
    }

    function validateStep(){
      var step=steps[current];
      clearError(step);

      if(current===0){
        var quantity=quantityValue();
        var min=Number(root.dataset.min);
        if(quantity===null){
          showError(step,'Enter the number of coins you want.');
          qty.focus();
          return false;
        }
        if(quantity<min){
          showError(step,'Minimum order is '+min+'. Please enter '+min+' or more.');
          qty.focus();
          return false;
        }
        syncPrice();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===1){
        if(!root.querySelector('[data-base]:checked')){
          showError(step,'Choose a chip color.');
          return false;
        }
        filterImprints();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===2){
        if(!root.querySelector('[data-imprint]:checked')){
          showError(step,'Choose an imprint color.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='aluminum'&&current===1){
        if(!root.querySelector('input[name="properties[Kalodized Coating]"]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='bronze'&&current===1){
        if(!root.querySelector('input[name="properties[Stock Die]"]:checked')){
          showError(step,'Choose an option.');
          return false;
        }
        return true;
      }

      if(step.querySelector('[data-art-group]')){
        if(!step.querySelector('[data-mode]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
      }

      return true;
    }

    function value(name){
      var el=root.querySelector('[name="'+name+'"]:checked')||root.querySelector('[name="'+name+'"]');
      return el?(el.value||''):'';
    }

    function renderReview(){
      syncPrice();
      var rows=[
        ['Quantity',qty.value],
        ['Price each',unitProp.value],
        ['Estimated total',totalProp.value]
      ];

      if(root.dataset.kind==='plastic'){
        rows.push(['Chip color',value('properties[Base Chip Color]')]);
        rows.push(['Imprint color',value('properties[Imprint Color]')]);
      } else if(root.dataset.kind==='aluminum'){
        rows.push(['Colored coating',value('properties[Kalodized Coating]')]);
      } else if(root.dataset.kind==='bronze'){
        rows.push(['Stock die',value('properties[Stock Die]')]);
      }

      rows.push(['Front',value('properties[Front Design Source]')]);

      if(Number(root.dataset.sides)===2){
        rows.push(['Back',value('properties[Back Design Source]')]);
      }

      review.innerHTML='';

      rows.forEach(function(row){
        var item=document.createElement('div');
        item.className='ccw__review-row';
        var label=document.createElement('b');
        label.textContent=row[0];
        var val=document.createElement('span');
        val.textContent=row[1];
        item.appendChild(label);
        item.appendChild(val);
        review.appendChild(item);
      });
    }

    function show(index){
      current=Math.max(0,Math.min(index,steps.length-1));

      steps.forEach(function(step,i){
        step.classList.toggle('is-active',i===current);
      });

      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===current);
      });

      stepTitle.textContent='Step '+(current+1)+' of '+steps.length+' · '+steps[current].dataset.label;
      back.hidden=current===0;
      next.hidden=current===steps.length-1;

      if(current===steps.length-1){
        renderReview();
      }
    }

    start.addEventListener('click',function(){
      intro.hidden=true;
      wizard.hidden=false;
      show(0);
      setTimeout(function(){qty.focus();},0);
    });

    qty.addEventListener('input',function(){
      clearError(steps[0]);
      syncPrice();
    });

    root.addEventListener('change',function(event){
      var step=event.target.closest('[data-step]');
      if(step){clearError(step);}

      if(event.target.matches('[data-base]')){
        filterImprints();
      }

      if(event.target.matches('[data-mode]')){
        updateArt(event.target.closest('[data-art-group]'));
      }
    });

    next.addEventListener('click',function(){
      if(validateStep()){show(current+1);}
    });

    back.addEventListener('click',function(){
      show(current-1);
    });

    form.addEventListener('submit',function(event){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);

      if(quantity===null||quantity<min){
        event.preventDefault();
        show(0);
        showError(steps[0],'Minimum order is '+min+'. Please enter '+min+' or more.');
        qty.focus();
        return;
      }

      syncPrice();
    });

    filterImprints();
    [].slice.call(root.querySelectorAll('[data-art-group]')).forEach(updateArt);
  }

  document.querySelectorAll('[data-ccw]').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-coin-wizard-v1636"] && !Shopify.designMode) return;
  try {
    (function(){
  function money(value){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(value);
  }

  function init(root){
    var intro=root.querySelector('[data-intro]');
    var wizard=root.querySelector('[data-wizard]');
    var start=root.querySelector('[data-start]');
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var stepTitle=root.querySelector('[data-step-title]');
    var next=root.querySelector('[data-next]');
    var back=root.querySelector('[data-back]');
    var form=root.querySelector('form');
    var qty=root.querySelector('[data-qty]');
    var cartQty=root.querySelector('[data-cart-qty]');
    var unitProp=root.querySelector('[data-unit-prop]');
    var totalProp=root.querySelector('[data-total-prop]');
    var tierProp=root.querySelector('[data-tier-prop]');
    var review=root.querySelector('[data-review]');
    var pricing=JSON.parse(root.querySelector('[data-pricing]').textContent);
    var current=0;

    function clearError(step){
      var error=step.querySelector('[data-error]');
      if(error){error.hidden=true;error.textContent='';}
    }

    function showError(step,message){
      var error=step.querySelector('[data-error]');
      if(error){error.textContent=message;error.hidden=false;}
    }

    function tierFor(quantity){
      var tier=pricing.tiers[0];
      pricing.tiers.forEach(function(candidate){
        if(quantity>=candidate.min&&(candidate.max===null||quantity<=candidate.max)){tier=candidate;}
      });
      return tier;
    }

    function quantityValue(){
      var raw=qty.value.trim();
      if(raw===''){return null;}
      var value=Number(raw);
      if(!Number.isInteger(value)){return null;}
      return value;
    }

    function syncPrice(){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);
      if(quantity===null||quantity<min){
        return;
      }
      var tier=tierFor(quantity);
      cartQty.value=quantity;
      unitProp.value=money(tier.price);
      totalProp.value=money(tier.price*quantity);
      tierProp.value=String(tier.min)+(tier.max===null?'+':'–'+tier.max)+' @ '+money(tier.price);
    }

    function filterImprints(){
      var base=root.querySelector('[data-base]:checked');
      [].slice.call(root.querySelectorAll('[data-for-base]')).forEach(function(card){
        var show=base&&card.dataset.forBase===base.value;
        card.hidden=!show;
        var input=card.querySelector('[data-imprint]');
        if(input&&!show){input.checked=false;}
      });
    }

    function updateArt(group){
      var selected=group.querySelector('[data-mode]:checked');
      var step=group.closest('[data-step]');
      [].slice.call(step.querySelectorAll('[data-panel]')).forEach(function(panel){
        panel.hidden=!selected||panel.dataset.panel!==selected.dataset.mode;
      });
    }

    function validateStep(){
      var step=steps[current];
      clearError(step);

      if(current===0){
        var quantity=quantityValue();
        var min=Number(root.dataset.min);
        if(quantity===null){
          showError(step,'Enter the number of coins you want.');
          qty.focus();
          return false;
        }
        if(quantity<min){
          showError(step,'Minimum order is '+min+'. Please enter '+min+' or more.');
          qty.focus();
          return false;
        }
        syncPrice();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===1){
        if(!root.querySelector('[data-base]:checked')){
          showError(step,'Choose a chip color.');
          return false;
        }
        filterImprints();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===2){
        if(!root.querySelector('[data-imprint]:checked')){
          showError(step,'Choose an imprint color.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='aluminum'&&current===1){
        if(!root.querySelector('input[name="properties[Kalodized Coating]"]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='bronze'&&current===1){
        if(!root.querySelector('input[name="properties[Stock Die]"]:checked')){
          showError(step,'Choose an option.');
          return false;
        }
        return true;
      }

      if(step.querySelector('[data-art-group]')){
        if(!step.querySelector('[data-mode]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
      }

      return true;
    }

    function value(name){
      var el=root.querySelector('[name="'+name+'"]:checked')||root.querySelector('[name="'+name+'"]');
      return el?(el.value||''):'';
    }

    function renderReview(){
      syncPrice();
      var rows=[
        ['Quantity',qty.value],
        ['Price each',unitProp.value],
        ['Estimated total',totalProp.value]
      ];

      if(root.dataset.kind==='plastic'){
        rows.push(['Chip color',value('properties[Base Chip Color]')]);
        rows.push(['Imprint color',value('properties[Imprint Color]')]);
      } else if(root.dataset.kind==='aluminum'){
        rows.push(['Colored coating',value('properties[Kalodized Coating]')]);
      } else if(root.dataset.kind==='bronze'){
        rows.push(['Stock die',value('properties[Stock Die]')]);
      }

      rows.push(['Front',value('properties[Front Design Source]')]);

      if(Number(root.dataset.sides)===2){
        rows.push(['Back',value('properties[Back Design Source]')]);
      }

      review.innerHTML='';

      rows.forEach(function(row){
        var item=document.createElement('div');
        item.className='ccw__review-row';
        var label=document.createElement('b');
        label.textContent=row[0];
        var val=document.createElement('span');
        val.textContent=row[1];
        item.appendChild(label);
        item.appendChild(val);
        review.appendChild(item);
      });
    }

    function show(index){
      current=Math.max(0,Math.min(index,steps.length-1));

      steps.forEach(function(step,i){
        step.classList.toggle('is-active',i===current);
      });

      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===current);
      });

      stepTitle.textContent='Step '+(current+1)+' of '+steps.length+' · '+steps[current].dataset.label;
      back.hidden=current===0;
      next.hidden=current===steps.length-1;

      if(current===steps.length-1){
        renderReview();
      }
    }

    start.addEventListener('click',function(){
      intro.hidden=true;
      wizard.hidden=false;
      show(0);
      setTimeout(function(){qty.focus();},0);
    });

    qty.addEventListener('input',function(){
      clearError(steps[0]);
      syncPrice();
    });

    root.addEventListener('change',function(event){
      var step=event.target.closest('[data-step]');
      if(step){clearError(step);}

      if(event.target.matches('[data-base]')){
        filterImprints();
      }

      if(event.target.matches('[data-mode]')){
        updateArt(event.target.closest('[data-art-group]'));
      }
    });

    next.addEventListener('click',function(){
      if(validateStep()){show(current+1);}
    });

    back.addEventListener('click',function(){
      show(current-1);
    });

    form.addEventListener('submit',function(event){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);

      if(quantity===null||quantity<min){
        event.preventDefault();
        show(0);
        showError(steps[0],'Minimum order is '+min+'. Please enter '+min+' or more.');
        qty.focus();
        return;
      }

      syncPrice();
    });

    filterImprints();
    [].slice.call(root.querySelectorAll('[data-art-group]')).forEach(updateArt);
  }

  document.querySelectorAll('[data-ccw]').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-coin-wizard-v1637"] && !Shopify.designMode) return;
  try {
    (function(){
  function money(value){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(value);
  }

  function init(root){
    var intro=root.querySelector('[data-intro]');
    var wizard=root.querySelector('[data-wizard]');
    var start=root.querySelector('[data-start]');
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var stepTitle=root.querySelector('[data-step-title]');
    var next=root.querySelector('[data-next]');
    var back=root.querySelector('[data-back]');
    var finalAdd=root.querySelector('[data-final-add]');
    var nav=root.querySelector('[data-nav]');
    var form=root.querySelector('form');
    var qty=root.querySelector('[data-qty]');
    var cartQty=root.querySelector('[data-cart-qty]');
    var unitProp=root.querySelector('[data-unit-prop]');
    var totalProp=root.querySelector('[data-total-prop]');
    var tierProp=root.querySelector('[data-tier-prop]');
    var review=root.querySelector('[data-review]');
    var pricing=JSON.parse(root.querySelector('[data-pricing]').textContent);
    var current=0;

    function clearError(step){
      var error=step.querySelector('[data-error]');
      if(error){error.hidden=true;error.textContent='';}
    }

    function showError(step,message){
      var error=step.querySelector('[data-error]');
      if(error){error.textContent=message;error.hidden=false;}
    }

    function tierFor(quantity){
      var tier=pricing.tiers[0];
      pricing.tiers.forEach(function(candidate){
        if(quantity>=candidate.min&&(candidate.max===null||quantity<=candidate.max)){tier=candidate;}
      });
      return tier;
    }

    function quantityValue(){
      var raw=qty.value.trim();
      if(raw===''){return null;}
      var value=Number(raw);
      if(!Number.isInteger(value)){return null;}
      return value;
    }

    function syncPrice(){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);
      if(quantity===null||quantity<min){
        return;
      }
      var tier=tierFor(quantity);
      cartQty.value=quantity;
      unitProp.value=money(tier.price);
      totalProp.value=money(tier.price*quantity);
      tierProp.value=String(tier.min)+(tier.max===null?'+':'–'+tier.max)+' @ '+money(tier.price);
    }

    function filterImprints(){
      var base=root.querySelector('[data-base]:checked');
      [].slice.call(root.querySelectorAll('[data-for-base]')).forEach(function(card){
        var show=base&&card.dataset.forBase===base.value;
        card.hidden=!show;
        var input=card.querySelector('[data-imprint]');
        if(input&&!show){input.checked=false;}
      });
    }

    function updateArt(group){
      var selected=group.querySelector('[data-mode]:checked');
      var step=group.closest('[data-step]');
      [].slice.call(step.querySelectorAll('[data-panel]')).forEach(function(panel){
        panel.hidden=!selected||panel.dataset.panel!==selected.dataset.mode;
      });
    }

    function validateStep(){
      var step=steps[current];
      clearError(step);

      if(current===0){
        var quantity=quantityValue();
        var min=Number(root.dataset.min);
        if(quantity===null){
          showError(step,'Enter the number of coins you want.');
          qty.focus();
          return false;
        }
        if(quantity<min){
          showError(step,'Minimum order is '+min+'. Please enter '+min+' or more.');
          qty.focus();
          return false;
        }
        syncPrice();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===1){
        if(!root.querySelector('[data-base]:checked')){
          showError(step,'Choose a chip color.');
          return false;
        }
        filterImprints();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===2){
        if(!root.querySelector('[data-imprint]:checked')){
          showError(step,'Choose an imprint color.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='aluminum'&&current===1){
        if(!root.querySelector('input[name="properties[Kalodized Coating]"]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='bronze'&&current===1){
        if(!root.querySelector('input[name="properties[Stock Die]"]:checked')){
          showError(step,'Choose an option.');
          return false;
        }
        return true;
      }

      if(step.querySelector('[data-art-group]')){
        if(!step.querySelector('[data-mode]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
      }

      return true;
    }

    function value(name){
      var el=root.querySelector('[name="'+name+'"]:checked')||root.querySelector('[name="'+name+'"]');
      return el?(el.value||''):'';
    }

    function renderReview(){
      syncPrice();
      var rows=[
        ['Quantity',qty.value],
        ['Price each',unitProp.value],
        ['Estimated total',totalProp.value]
      ];

      if(root.dataset.kind==='plastic'){
        rows.push(['Chip color',value('properties[Base Chip Color]')]);
        rows.push(['Imprint color',value('properties[Imprint Color]')]);
      } else if(root.dataset.kind==='aluminum'){
        rows.push(['Colored coating',value('properties[Kalodized Coating]')]);
      } else if(root.dataset.kind==='bronze'){
        rows.push(['Stock die',value('properties[Stock Die]')]);
      }

      rows.push(['Front',value('properties[Front Design Source]')]);

      if(Number(root.dataset.sides)===2){
        rows.push(['Back',value('properties[Back Design Source]')]);
      }

      review.innerHTML='';

      rows.forEach(function(row){
        var item=document.createElement('div');
        item.className='ccw__review-row';
        var label=document.createElement('b');
        label.textContent=row[0];
        var val=document.createElement('span');
        val.textContent=row[1];
        item.appendChild(label);
        item.appendChild(val);
        review.appendChild(item);
      });
    }

    function show(index){
      current=Math.max(0,Math.min(index,steps.length-1));

      steps.forEach(function(step,i){
        step.classList.toggle('is-active',i===current);
      });

      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===current);
      });

      stepTitle.textContent='Step '+(current+1)+' of '+steps.length+' · '+steps[current].dataset.label;
      var isFinal=current===steps.length-1;
      back.hidden=current===0;
      next.hidden=isFinal;
      finalAdd.hidden=!isFinal;
      nav.classList.toggle('is-final',isFinal);

      if(isFinal){
        renderReview();
      }
    }

    start.addEventListener('click',function(){
      intro.hidden=true;
      wizard.hidden=false;
      show(0);
      setTimeout(function(){qty.focus();},0);
    });

    qty.addEventListener('input',function(){
      clearError(steps[0]);
      syncPrice();
    });

    root.addEventListener('change',function(event){
      var step=event.target.closest('[data-step]');
      if(step){clearError(step);}

      if(event.target.matches('[data-base]')){
        filterImprints();
      }

      if(event.target.matches('[data-mode]')){
        updateArt(event.target.closest('[data-art-group]'));
      }
    });

    next.addEventListener('click',function(){
      if(validateStep()){show(current+1);}
    });

    back.addEventListener('click',function(){
      show(current-1);
    });

    form.addEventListener('submit',function(event){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);

      if(quantity===null||quantity<min){
        event.preventDefault();
        show(0);
        showError(steps[0],'Minimum order is '+min+'. Please enter '+min+' or more.');
        qty.focus();
        return;
      }

      syncPrice();
    });

    filterImprints();
    [].slice.call(root.querySelectorAll('[data-art-group]')).forEach(updateArt);
  }

  document.querySelectorAll('[data-ccw]').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-coin-wizard-v1638"] && !Shopify.designMode) return;
  try {
    (function(){
  function money(value){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(value);
  }

  function init(root){
    var intro=root.querySelector('[data-intro]');
    var wizard=root.querySelector('[data-wizard]');
    var start=root.querySelector('[data-start]');
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var stepTitle=root.querySelector('[data-step-title]');
    var next=root.querySelector('[data-next]');
    var back=root.querySelector('[data-back]');
    var finalAdd=root.querySelector('[data-final-add]');
    var nav=root.querySelector('[data-nav]');
    var form=root.querySelector('form');
    var qty=root.querySelector('[data-qty]');
    var cartQty=root.querySelector('[data-cart-qty]');
    var unitProp=root.querySelector('[data-unit-prop]');
    var totalProp=root.querySelector('[data-total-prop]');
    var tierProp=root.querySelector('[data-tier-prop]');
    var review=root.querySelector('[data-review]');
    var pricing=JSON.parse(root.querySelector('[data-pricing]').textContent);
    var current=0;

    function clearError(step){
      var error=step.querySelector('[data-error]');
      if(error){error.hidden=true;error.textContent='';}
    }

    function showError(step,message){
      var error=step.querySelector('[data-error]');
      if(error){error.textContent=message;error.hidden=false;}
    }

    function tierFor(quantity){
      var tier=pricing.tiers[0];
      pricing.tiers.forEach(function(candidate){
        if(quantity>=candidate.min&&(candidate.max===null||quantity<=candidate.max)){tier=candidate;}
      });
      return tier;
    }

    function quantityValue(){
      var raw=qty.value.trim();
      if(raw===''){return null;}
      var value=Number(raw);
      if(!Number.isInteger(value)){return null;}
      return value;
    }

    function syncPrice(){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);
      if(quantity===null||quantity<min){
        return;
      }
      var tier=tierFor(quantity);
      cartQty.value=quantity;
      unitProp.value=money(tier.price);
      totalProp.value=money(tier.price*quantity);
      tierProp.value=String(tier.min)+(tier.max===null?'+':'–'+tier.max)+' @ '+money(tier.price);
    }

    function filterImprints(){
      var base=root.querySelector('[data-base]:checked');
      [].slice.call(root.querySelectorAll('[data-for-base]')).forEach(function(card){
        var show=base&&card.dataset.forBase===base.value;
        card.hidden=!show;
        var input=card.querySelector('[data-imprint]');
        if(input&&!show){input.checked=false;}
      });
    }

    function updateArt(group){
      var selected=group.querySelector('[data-mode]:checked');
      var step=group.closest('[data-step]');
      [].slice.call(step.querySelectorAll('[data-panel]')).forEach(function(panel){
        panel.hidden=!selected||panel.dataset.panel!==selected.dataset.mode;
      });
    }

    function validateStep(){
      var step=steps[current];
      clearError(step);

      if(current===0){
        var quantity=quantityValue();
        var min=Number(root.dataset.min);
        if(quantity===null){
          showError(step,'Enter the number of coins you want.');
          qty.focus();
          return false;
        }
        if(quantity<min){
          showError(step,'Minimum order is '+min+'. Please enter '+min+' or more.');
          qty.focus();
          return false;
        }
        syncPrice();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===1){
        if(!root.querySelector('[data-base]:checked')){
          showError(step,'Choose a chip color.');
          return false;
        }
        filterImprints();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===2){
        if(!root.querySelector('[data-imprint]:checked')){
          showError(step,'Choose an imprint color.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='aluminum'&&current===1){
        if(!root.querySelector('input[name="properties[Kalodized Coating]"]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='bronze'&&current===1){
        if(!root.querySelector('input[name="properties[Stock Die]"]:checked')){
          showError(step,'Choose an option.');
          return false;
        }
        return true;
      }

      if(step.querySelector('[data-art-group]')){
        if(!step.querySelector('[data-mode]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
      }

      return true;
    }

    function value(name){
      var el=root.querySelector('[name="'+name+'"]:checked')||root.querySelector('[name="'+name+'"]');
      return el?(el.value||''):'';
    }

    function renderReview(){
      syncPrice();
      var rows=[
        ['Quantity',qty.value],
        ['Price each',unitProp.value],
        ['Estimated total',totalProp.value]
      ];

      if(root.dataset.kind==='plastic'){
        rows.push(['Chip color',value('properties[Base Chip Color]')]);
        rows.push(['Imprint color',value('properties[Imprint Color]')]);
      } else if(root.dataset.kind==='aluminum'){
        rows.push(['Colored coating',value('properties[Kalodized Coating]')]);
      } else if(root.dataset.kind==='bronze'){
        rows.push(['Stock die',value('properties[Stock Die]')]);
      }

      rows.push(['Front',value('properties[Front Design Source]')]);

      if(Number(root.dataset.sides)===2){
        rows.push(['Back',value('properties[Back Design Source]')]);
      }

      review.innerHTML='';

      rows.forEach(function(row){
        var item=document.createElement('div');
        item.className='ccw__review-row';
        var label=document.createElement('b');
        label.textContent=row[0];
        var val=document.createElement('span');
        val.textContent=row[1];
        item.appendChild(label);
        item.appendChild(val);
        review.appendChild(item);
      });
    }

    function show(index){
      current=Math.max(0,Math.min(index,steps.length-1));

      steps.forEach(function(step,i){
        step.classList.toggle('is-active',i===current);
      });

      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===current);
      });

      stepTitle.textContent='Step '+(current+1)+' of '+steps.length+' · '+steps[current].dataset.label;
      var isFinal=current===steps.length-1;
      back.hidden=current===0;
      next.hidden=isFinal;
      finalAdd.hidden=!isFinal;
      nav.classList.toggle('is-final',isFinal);

      if(isFinal){
        renderReview();
      }
    }

    start.addEventListener('click',function(){
      intro.hidden=true;
      wizard.hidden=false;
      show(0);
      setTimeout(function(){qty.focus();},0);
    });

    qty.addEventListener('input',function(){
      clearError(steps[0]);
      syncPrice();
    });

    root.addEventListener('change',function(event){
      var step=event.target.closest('[data-step]');
      if(step){clearError(step);}

      if(event.target.matches('[data-base]')){
        filterImprints();
      }

      if(event.target.matches('[data-mode]')){
        updateArt(event.target.closest('[data-art-group]'));
      }
    });

    next.addEventListener('click',function(){
      if(validateStep()){show(current+1);}
    });

    back.addEventListener('click',function(){
      show(current-1);
    });

    form.addEventListener('submit',function(event){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);

      if(quantity===null||quantity<min){
        event.preventDefault();
        show(0);
        showError(steps[0],'Minimum order is '+min+'. Please enter '+min+' or more.');
        qty.focus();
        return;
      }

      syncPrice();
    });

    filterImprints();
    [].slice.call(root.querySelectorAll('[data-art-group]')).forEach(updateArt);
  }

  document.querySelectorAll('[data-ccw]').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-coin-wizard-v1639"] && !Shopify.designMode) return;
  try {
    (function(){
  function money(value){
    return new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(value);
  }

  function init(root){
    var intro=root.querySelector('[data-intro]');
    var wizard=root.querySelector('[data-wizard]');
    var start=root.querySelector('[data-start]');
    var steps=[].slice.call(root.querySelectorAll('[data-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-dot]'));
    var stepTitle=root.querySelector('[data-step-title]');
    var next=root.querySelector('[data-next]');
    var back=root.querySelector('[data-back]');
    var finalAdd=root.querySelector('[data-final-add]');
    var nav=root.querySelector('[data-nav]');
    var form=root.querySelector('form');
    var variantInput=root.querySelector('[data-variant-id]');
    var qty=root.querySelector('[data-qty]');
    var cartQty=root.querySelector('[data-cart-qty]');
    var unitProp=root.querySelector('[data-unit-prop]');
    var totalProp=root.querySelector('[data-total-prop]');
    var tierProp=root.querySelector('[data-tier-prop]');
    var review=root.querySelector('[data-review]');
    var pricing=JSON.parse(root.querySelector('[data-pricing]').textContent);
    var current=0;

    function clearError(step){
      var error=step.querySelector('[data-error]');
      if(error){error.hidden=true;error.textContent='';}
    }

    function showError(step,message){
      var error=step.querySelector('[data-error]');
      if(error){error.textContent=message;error.hidden=false;}
    }

    function tierFor(quantity){
      var tier=pricing.tiers[0];
      pricing.tiers.forEach(function(candidate){
        if(quantity>=candidate.min&&(candidate.max===null||quantity<=candidate.max)){tier=candidate;}
      });
      return tier;
    }

    function quantityValue(){
      var raw=qty.value.trim();
      if(raw===''){return null;}
      var value=Number(raw);
      if(!Number.isInteger(value)){return null;}
      return value;
    }

    function isFullColor(){
      var selected=root.querySelector('[data-imprint]:checked');
      return !!(selected&&selected.dataset.fullColor==='true');
    }

    function syncVariant(){
      if(root.dataset.kind!=='plastic'||!variantInput){return;}
      var target=isFullColor()?root.dataset.fullColorVariant:root.dataset.standardVariant;
      if(target){variantInput.value=target;}
    }

    function syncPrice(){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);
      if(quantity===null||quantity<min){
        return;
      }
      var tier=tierFor(quantity);
      var each=tier.price;
      if(root.dataset.kind==='plastic'&&isFullColor()){
        each+=Number(root.dataset.fullColorUpcharge||0);
      }
      cartQty.value=quantity;
      unitProp.value=money(each);
      totalProp.value=money(each*quantity);
      tierProp.value=String(tier.min)+(tier.max===null?'+':'–'+tier.max)+' @ '+money(each);
      syncVariant();
    }

    function filterImprints(){
      var base=root.querySelector('[data-base]:checked');
      [].slice.call(root.querySelectorAll('[data-for-base]')).forEach(function(card){
        var show=base&&card.dataset.forBase===base.value;
        card.hidden=!show;
        var input=card.querySelector('[data-imprint]');
        if(input&&!show){input.checked=false;}
      });
      syncVariant();
    }

    function updateArt(group){
      var selected=group.querySelector('[data-mode]:checked');
      var step=group.closest('[data-step]');
      [].slice.call(step.querySelectorAll('[data-panel]')).forEach(function(panel){
        panel.hidden=!selected||panel.dataset.panel!==selected.dataset.mode;
      });
    }

    function validateStep(){
      var step=steps[current];
      clearError(step);

      if(current===0){
        var quantity=quantityValue();
        var min=Number(root.dataset.min);
        if(quantity===null){
          showError(step,'Enter the number of coins you want.');
          qty.focus();
          return false;
        }
        if(quantity<min){
          showError(step,'Minimum order is '+min+'. Please enter '+min+' or more.');
          qty.focus();
          return false;
        }
        syncPrice();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===1){
        if(!root.querySelector('[data-base]:checked')){
          showError(step,'Choose a chip color.');
          return false;
        }
        filterImprints();
        return true;
      }

      if(root.dataset.kind==='plastic'&&current===2){
        if(!root.querySelector('[data-imprint]:checked')){
          showError(step,'Choose an imprint color.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='aluminum'&&current===1){
        if(!root.querySelector('input[name="properties[Kalodized Coating]"]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
        return true;
      }

      if(root.dataset.kind==='bronze'&&current===1){
        if(!root.querySelector('input[name="properties[Stock Die]"]:checked')){
          showError(step,'Choose an option.');
          return false;
        }
        return true;
      }

      if(step.querySelector('[data-art-group]')){
        if(!step.querySelector('[data-mode]:checked')){
          showError(step,'Choose Yes or No.');
          return false;
        }
      }

      return true;
    }

    function value(name){
      var el=root.querySelector('[name="'+name+'"]:checked')||root.querySelector('[name="'+name+'"]');
      return el?(el.value||''):'';
    }

    function renderReview(){
      syncPrice();
      var rows=[
        ['Quantity',qty.value],
        ['Price each',unitProp.value],
        ['Estimated total',totalProp.value]
      ];

      if(root.dataset.kind==='plastic'){
        rows.push(['Chip color',value('properties[Base Chip Color]')]);
        rows.push(['Imprint color',value('properties[Imprint Color]')]);
      } else if(root.dataset.kind==='aluminum'){
        rows.push(['Colored coating',value('properties[Kalodized Coating]')]);
      } else if(root.dataset.kind==='bronze'){
        rows.push(['Stock die',value('properties[Stock Die]')]);
      }

      rows.push(['Front',value('properties[Front Design Source]')]);

      if(Number(root.dataset.sides)===2){
        rows.push(['Back',value('properties[Back Design Source]')]);
      }

      review.innerHTML='';

      rows.forEach(function(row){
        var item=document.createElement('div');
        item.className='ccw__review-row';
        var label=document.createElement('b');
        label.textContent=row[0];
        var val=document.createElement('span');
        val.textContent=row[1];
        item.appendChild(label);
        item.appendChild(val);
        review.appendChild(item);
      });
    }

    function show(index){
      current=Math.max(0,Math.min(index,steps.length-1));

      steps.forEach(function(step,i){
        step.classList.toggle('is-active',i===current);
      });

      dots.forEach(function(dot,i){
        dot.classList.toggle('is-active',i===current);
      });

      stepTitle.textContent='Step '+(current+1)+' of '+steps.length+' · '+steps[current].dataset.label;
      var isFinal=current===steps.length-1;
      back.hidden=current===0;
      next.hidden=isFinal;
      finalAdd.hidden=!isFinal;
      nav.classList.toggle('is-final',isFinal);

      if(isFinal){
        renderReview();
      }
    }

    start.addEventListener('click',function(){
      intro.hidden=true;
      wizard.hidden=false;
      show(0);
      setTimeout(function(){qty.focus();},0);
    });

    qty.addEventListener('input',function(){
      clearError(steps[0]);
      syncVariant();
      syncPrice();
    });

    root.addEventListener('change',function(event){
      var step=event.target.closest('[data-step]');
      if(step){clearError(step);}

      if(event.target.matches('[data-base]')){
        filterImprints();
      }

      if(event.target.matches('[data-imprint]')){
        syncVariant();
        syncPrice();
      }

      if(event.target.matches('[data-mode]')){
        updateArt(event.target.closest('[data-art-group]'));
      }
    });

    next.addEventListener('click',function(){
      if(validateStep()){show(current+1);}
    });

    back.addEventListener('click',function(){
      show(current-1);
    });

    form.addEventListener('submit',function(event){
      var quantity=quantityValue();
      var min=Number(root.dataset.min);

      if(quantity===null||quantity<min){
        event.preventDefault();
        show(0);
        showError(steps[0],'Minimum order is '+min+'. Please enter '+min+' or more.');
        qty.focus();
        return;
      }

      syncPrice();
    });

    filterImprints();
    [].slice.call(root.querySelectorAll('[data-art-group]')).forEach(updateArt);
  }

  document.querySelectorAll('[data-ccw]').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

})();
